import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.regexp.replace";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime-corejs2/regenerator";
import "core-js/modules/es6.array.of";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.to-string";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/app/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import "core-js/modules/es6.object.freeze";
import { API_REQUEST } from "../../api/";
import { replacer, i18n } from '@/boot/i18n'; // import messages from 'src/i18n'
// , setLocaleMessage VueI18n

import { menuRestrictions } from "../../modules/restrictions";
import { setQuasarInternalLanguage } from "../../modules/quasarInternalLanguage";
import quasarColors from 'quasar/src/utils/colors.js';;
import Cookies from 'js-cookie'; // import { WordReplacer } from '../../modules/word-replacer'

var RT = {
  root: true
};
var state = {
  loading: undefined,
  allowedFunctions: null,
  allowedTabs: [],
  menu: [],
  exitMenuItem: {},
  locale: false,
  primaryPageLoaded: false,
  logoUrl: false,
  layout: false,
  embedMode: undefined,
  feedback: {}
};
var mutations = {
  setPrimaryPageLoaded: function setPrimaryPageLoaded(state, _ref) {
    var value = _ref.value;
    state.primaryPageLoaded = value;
  },
  setLocale: function setLocale(state, _ref2) {
    var value = _ref2.value;
    state.locale = value;
  },
  setLoading: function setLoading(state, _ref3) {
    var value = _ref3.value;
    state.loading = value;
  },
  setMenu: function setMenu(state, _ref4) {
    var value = _ref4.value;
    state.menu = value;
  },
  setExitMenuItem: function setExitMenuItem(state, _ref5) {
    var value = _ref5.value;
    state.exitMenuItem = value;
  },
  setAllowedFunctions: function setAllowedFunctions(state, _ref6) {
    var value = _ref6.value;
    state.allowedFunctions = Object.freeze(value); // non-reactive
  },
  setLogoUrl: function setLogoUrl(state, _ref7) {
    var value = _ref7.value;
    state.logoUrl = value;
  },
  setLayout: function setLayout(state, _ref8) {
    var value = _ref8.value;
    state.layout = value;
    console.log('current layout:', value);
  },
  setEmbedMode: function setEmbedMode(state, _ref9) {
    var value = _ref9.value;
    state.embedMode = value;
  },
  setAllowedTabs: function setAllowedTabs(state, tabs) {
    state.allowedTabs = tabs;
  },
  setFeedback: function setFeedback(state, data) {
    state.feedback = data;
  }
};
var actions = {
  initialize: function initialize(_ref10) {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
      var state, commit, dispatch, rootState;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              state = _ref10.state, commit = _ref10.commit, dispatch = _ref10.dispatch, rootState = _ref10.rootState;
              console.log('Initializing app');
              return _context2.abrupt("return", new Promise(function (resolve, reject) {
                commit('setLoading', {
                  value: true
                });
                var Router = _this.$router;
                Router.onReady( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
                  var _window$location$href;

                  var userInfoAnswer, _userInfoAnswer$1$all, clientCustomization, defaultStats, workerId, allowedFuncsResult, allowedFunctions, feedback, currentLayout, currPath, pathIsInitial, path;

                  return _regeneratorRuntime.wrap(function _callee$(_context) {
                    while (1) {
                      switch (_context.prev = _context.next) {
                        case 0:
                          commit('setEmbedMode', {
                            value: window.location !== window.parent.location
                          });
                          _context.next = 3;
                          return API_REQUEST('getUserInfo');

                        case 3:
                          userInfoAnswer = _context.sent;

                          if (!(window.location !== window.parent.location && (_window$location$href = window.location.href) !== null && _window$location$href !== void 0 && _window$location$href.includes('removeSession'))) {
                            _context.next = 12;
                            break;
                          }

                          console.log('"removeSession" action found in query string.');
                          _context.next = 8;
                          return API_REQUEST('logOut');

                        case 8:
                          if (Cookies.get('csrftoken')) {
                            window.parent.postMessage({
                              source: 'mm-embed',
                              type: 'authRequired',
                              csrfToken: Cookies.get('csrftoken')
                            }, '*');
                          }

                          commit('setLoading', {
                            value: false
                          });
                          resolve();
                          return _context.abrupt("return");

                        case 12:
                          if (!userInfoAnswer[1]) {
                            _context.next = 43;
                            break;
                          }

                          console.log('Received user info');
                          clientCustomization = userInfoAnswer[1].network;

                          if (clientCustomization) {
                            quasarColors.setBrand('primary', clientCustomization['primary_color']);
                            document.documentElement.style.setProperty('--q-color-primary', clientCustomization['primary_color']);
                            quasarColors.setBrand('secondary', clientCustomization['secondary_color']);
                            document.documentElement.style.setProperty('--q-color-secondary', clientCustomization['secondary_color']);
                            commit('setLogoUrl', {
                              value: clientCustomization['logo']
                            });
                          }

                          defaultStats = userInfoAnswer[1].network.default_stats;
                          commit('user/setData', {
                            value: userInfoAnswer[1]
                          }, RT);
                          replacer.init(rootState.user.data.network, i18n);
                          commit('timetable/setDefaultStats', defaultStats, RT);
                          workerId = rootState.user.data.id;
                          _context.next = 23;
                          return API_REQUEST('getAllowedFunctions', {
                            'worker_id': workerId
                          });

                        case 23:
                          allowedFuncsResult = _context.sent;

                          if (((_userInfoAnswer$1$all = userInfoAnswer[1]['allowed_tabs']) === null || _userInfoAnswer$1$all === void 0 ? void 0 : _userInfoAnswer$1$all.length) > 0) {
                            commit('setAllowedTabs', userInfoAnswer[1]['allowed_tabs']);
                          }

                          if (!Array.isArray(allowedFuncsResult[1])) {
                            _context.next = 31;
                            break;
                          }

                          allowedFunctions = allowedFuncsResult[1].map(function (obj) {
                            return obj.func;
                          });
                          commit('setAllowedFunctions', {
                            value: allowedFunctions
                          });
                          dispatch('updateMenu');
                          _context.next = 37;
                          break;

                        case 31:
                          document.dispatchEvent(new CustomEvent('apiRequestError', {
                            detail: {
                              error: {
                                message: 'Allowed functions not found'
                              }
                            }
                          }));
                          commit('setLoading', {
                            value: false
                          });
                          Router.push({
                            path: '/login'
                          }).catch(function () {});
                          commit('setLayout', {
                            value: 'Login'
                          });
                          reject();
                          return _context.abrupt("return");

                        case 37:
                          _context.next = 39;
                          return API_REQUEST('getContentBlock', {
                            code: 'support_modal_text'
                          });

                        case 39:
                          feedback = _context.sent;
                          if (feedback[0] === false) commit('setFeedback', feedback[1][0]);
                          _context.next = 44;
                          break;

                        case 43:
                          console.log('User info not received');

                        case 44:
                          currentLayout = userInfoAnswer[1] ? 'Main' : 'Login';
                          _context.t0 = currentLayout;
                          _context.next = _context.t0 === 'Login' ? 48 : _context.t0 === 'Main' ? 51 : 56;
                          break;

                        case 48:
                          Router.push({
                            path: '/login'
                          }).catch(function () {});
                          console.log('Redirected to "Login" in "initialize"');
                          return _context.abrupt("break", 56);

                        case 51:
                          currPath = Router.currentRoute.path;
                          pathIsInitial = Array.of('/', '/login').includes(currPath);
                          path = pathIsInitial ? '/timetable' : currPath;

                          if (path !== currPath) {
                            console.log('Redirected to main route in "initialize"');
                            Router.push({
                              path: path,
                              query: Router.currentRoute.query
                            });
                          }

                          return _context.abrupt("break", 56);

                        case 56:
                          commit('setLoading', {
                            value: false
                          });
                          commit('setLayout', {
                            value: currentLayout
                          });
                          resolve();

                        case 59:
                        case "end":
                          return _context.stop();
                      }
                    }
                  }, _callee);
                })));
              }));

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  exit: function exit(_ref12) {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
      var commit;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref12.commit;
              console.log('Logout');
              commit('setLayout', {
                value: 'Login'
              });

              _this2.$router.push({
                path: '/login'
              });

            case 4:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  },
  updateMenu: function updateMenu(_ref13) {
    var commit = _ref13.commit;

    if (state.allowedFunctions) {
      var allMenuItems = i18n.messages[i18n.locale].menu;
      var menuItems = allMenuItems.filter(function (menuItem) {
        var pageName = menuItem.path.replace('/', '');
        var pageAllowedTab = menuItem.allowedTab;
        var pageRestrictions = menuRestrictions[pageName] || [];
        return pageRestrictions.every(function (item) {
          return state.allowedFunctions.findIndex(function (allowedFuncName) {
            return allowedFuncName === item;
          }) > -1;
        }) && state.allowedTabs.includes(pageAllowedTab);
      });
      commit('setMenu', {
        value: menuItems
      });
      commit('setExitMenuItem', {
        value: i18n.messages[i18n.locale].layouts.main.exitMenuItem
      });
    }
  },
  changeLocale: function changeLocale(_ref14, locale) {
    var dispatch = _ref14.dispatch,
        commit = _ref14.commit;
    console.log('changeLocale', locale);
    i18n.locale = locale;
    var cookieLocale = locale.toLowerCase().slice(0, 2);
    document.cookie = "django_language=".concat(cookieLocale, ";");
    setQuasarInternalLanguage(locale);
    commit('setLocale', {
      value: locale
    });
    dispatch('updateMenu');
  }
};
export default {
  namespaced: true,
  mutations: mutations,
  actions: actions,
  state: state
};